import GqlClient from 'utils/graphqlService';
import GetHomeTopicsQuery from './Topics.gql';

const getTrendingTopics = async (_key, limit) => {
  const response = await GqlClient.query({
    query: GetHomeTopicsQuery,
    variables: {
      limit,
    },
  });

  return response;
};

export default getTrendingTopics;
